var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled from 'styled-components';
import { device } from '../../breakpoints';
import { NavMenu } from './NavMenu/NavMenu';
var NavPlaceholder = styled.nav(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  margin: auto;\n\n  @media ", " {\n    flex-direction: column;\n    width: 100%;\n    margin: initial;\n  }\n"], ["\n  position: relative;\n  margin: auto;\n\n  @media ", " {\n    flex-direction: column;\n    width: 100%;\n    margin: initial;\n  }\n"])), device.laptop);
export var NavArea = function (props) {
    var _a;
    return ((_a = props.items) === null || _a === void 0 ? void 0 : _a.length) > 0 ? React.createElement(NavMenu, __assign({}, props)) : React.createElement(NavPlaceholder, null);
};
var templateObject_1;
